import { FC } from 'react';
import { FloatButton } from 'antd';
import { FloatButtonProps } from 'antd/lib/float-button/interface';

export type ProFloatButtonProps = FloatButtonProps;
const Index: FC<FloatButtonProps> = props => {
  return (
    <FloatButton {...props} />
  );
};

export default Index;
